import { createAction, props } from '@ngrx/store'

export const loadNavigation = createAction('[Navigation] Load', props<{ navigation: any }>())
